// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1kUFi","logo":"styles_logo__NaMpa","subTitle":"styles_subTitle__jhe4p","guide":"styles_guide__Jk5oQ"};